// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth .container {
  padding: 0 24px 90px;
  height: 100%;
  position: relative;
}
.auth .presentation {
  padding-top: 30px;
}
.auth .presentation__footer {
  position: absolute;
  bottom: 25px;
  width: 100%;
  left: 0;
  padding: 0 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
}
.auth h2 {
  color: var(--sebrae-blue);
  font-family: var(--font-alegreya);
  font-size: 27px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 16px;
}
.auth h6 {
  background: linear-gradient(45deg, #9285F9 0%, #CD5BE8 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-family: var(--font-lato);
  font-size: 19px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 16px;
}
.auth p {
  font-family: var(--font-lato);
  font-size: 16px;
  font-weight: 400;
  line-height: 23.3px;
}
.auth .step figure {
  margin: 16px auto;
}
.auth .step figure img {
  width: 300px;
  margin: 0 auto;
}
.auth .pages-desktop, .auth .navigate-desktop {
  display: none;
}
@media screen and (min-width: 375px) {
  .auth .step figure {
    margin-bottom: 37px;
  }
}
@media screen and (min-width: 1200px) {
  .auth .container {
    max-width: 1300px;
  }
  .auth .steps {
    margin: 0 auto;
    width: 100%;
    max-width: 1024px;
  }
  .auth .step {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 127px;
    flex-direction: row-reverse;
  }
  .auth .step figure {
    margin: 0;
  }
  .auth .step figure img {
    width: auto;
  }
  .auth .step .text {
    position: relative;
    max-width: 339px;
  }
  .auth h2 {
    font-size: 33px;
  }
  .auth h6 {
    font-size: 23px;
  }
  .auth .presentation {
    padding-top: 12%;
  }
  .auth .presentation__footer {
    display: none;
  }
  .auth .pages-desktop {
    padding: 35px 0 16px;
    display: block;
  }
  .auth .navigate-desktop {
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/auth/index.scss"],"names":[],"mappings":"AACE;EACE,oBAAA;EACA,YAAA;EACA,kBAAA;AAAJ;AAEE;EACE,iBAAA;AAAJ;AAEI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAAN;AAGE;EACE,yBAAA;EAEE,iCAAA;EACA,eAAA;EACA,gBAAA;EAEF,gBAAA;EACA,mBAAA;AAHJ;AAKE;EACE,4DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;EAEE,6BAAA;EACA,eAAA;EACA,gBAAA;EAEF,gBAAA;EACA,mBAAA;AALJ;AAOE;EAEI,6BAAA;EACA,eAAA;EACA,gBAAA;EAEF,mBAAA;AAPJ;AAUI;EACE,iBAAA;AARN;AAUM;EACE,YAAA;EACA,cAAA;AARR;AAYE;EACE,aAAA;AAVJ;AAaE;EAEI;IACE,mBAAA;EAZN;AACF;AAeE;EACE;IACE,iBAAA;EAbJ;EAeE;IACE,cAAA;IACA,WAAA;IACA,iBAAA;EAbJ;EAeE;IACE,kBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,UAAA;IACA,2BAAA;EAbJ;EAeI;IACE,SAAA;EAbN;EAcM;IACE,WAAA;EAZR;EAeI;IACE,kBAAA;IACA,gBAAA;EAbN;EAgBE;IACE,eAAA;EAdJ;EAgBE;IACE,eAAA;EAdJ;EAgBE;IACE,gBAAA;EAdJ;EAgBI;IACE,aAAA;EAdN;EAiBE;IACE,oBAAA;IACA,cAAA;EAfJ;EAiBE;IACE,cAAA;EAfJ;AACF","sourcesContent":[".auth {\r\n  .container {\r\n    padding: 0 24px 90px;\r\n    height: 100%;\r\n    position: relative;\r\n  }\r\n  .presentation {\r\n    padding-top: 30px;\r\n\r\n    &__footer {\r\n      position: absolute;\r\n      bottom: 25px;\r\n      width: 100%;\r\n      left: 0;\r\n      padding: 0 24px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n      gap: 15px;\r\n    }\r\n  }\r\n  h2 {\r\n    color: var(--sebrae-blue);\r\n    font: {\r\n      family: var(--font-alegreya);\r\n      size: 27px;\r\n      weight: 700;\r\n    }\r\n    line-height: 1.2;\r\n    margin-bottom: 16px;\r\n  }\r\n  h6 {\r\n    background: linear-gradient(45deg, #9285F9 0%, #CD5BE8 100%);\r\n    background-clip: text;\r\n    -webkit-background-clip: text;\r\n    -webkit-text-fill-color: transparent;\r\n    font: {\r\n      family: var(--font-lato);\r\n      size: 19px;\r\n      weight: 700;\r\n    }\r\n    line-height: 1.2;\r\n    margin-bottom: 16px;\r\n  }\r\n  p {\r\n    font: {\r\n      family: var(--font-lato);\r\n      size: 16px;\r\n      weight: 400;\r\n    }\r\n    line-height: 23.3px;\r\n  }\r\n  .step {\r\n    figure {\r\n      margin: 16px auto;\r\n\r\n      img {\r\n        width: 300px;\r\n        margin: 0 auto;\r\n      }\r\n    }\r\n  }\r\n  .pages-desktop, .navigate-desktop {\r\n    display: none;\r\n  }\r\n\r\n  @media screen and (min-width: 375px) {\r\n    .step {\r\n      figure {\r\n        margin-bottom: 37px;\r\n      }\r\n    }\r\n  }\r\n  @media screen and (min-width: 1200px) {\r\n    .container {\r\n      max-width: 1300px;\r\n    }\r\n    .steps {\r\n      margin: 0 auto;\r\n      width: 100%;\r\n      max-width: 1024px;\r\n    }\r\n    .step {\r\n      position: relative;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      gap: 127px;\r\n      flex-direction: row-reverse;\r\n\r\n      figure {\r\n        margin: 0;\r\n        img {\r\n          width: auto;\r\n        }\r\n      }\r\n      .text {\r\n        position: relative;\r\n        max-width: 339px;\r\n      }\r\n    }\r\n    h2 {\r\n      font-size: 33px;\r\n    }\r\n    h6 {\r\n      font-size: 23px;\r\n    }\r\n    .presentation {\r\n      padding-top: 12%;\r\n\r\n      &__footer {\r\n        display: none;\r\n      }\r\n    }\r\n    .pages-desktop {\r\n      padding: 35px 0 16px;\r\n      display: block;\r\n    }\r\n    .navigate-desktop {\r\n      display: block;\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
